import {SESSION_STORAGE_ACTIVE_DEPT_NAME} from "../../config/constants"

export const setDepartment = (path: string, dept: string, rememberSelectedDepartment: boolean) => {
    if (rememberSelectedDepartment) {
        sessionStorage.setItem(SESSION_STORAGE_ACTIVE_DEPT_NAME, JSON.stringify({path, dept}))
    }
}
